var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useFormLogic } from "../modules/common/context/FormLogicContext";
import { ProgressBarType, } from "../types/forms";
import { getFillableFieldNamesForPage, getRequiredFieldNamesForPage, isPageVisible, isCorrectAnswer, getCorrectAnswerFieldNamesForPage, getCorrectAnswerMap, } from "../utils/forms-functions";
import { isValueFilled } from "../utils/helpers";
var getQuestionNames = function (pages, formValues, elementsTypeInfoByName) {
    var fillableNames = pages.flatMap(function (page) {
        if (!isPageVisible(page, formValues, elementsTypeInfoByName)) {
            return [];
        }
        return getFillableFieldNamesForPage(page, formValues, elementsTypeInfoByName);
    });
    var requiredNames = pages.flatMap(function (page) {
        if (!isPageVisible(page, formValues, elementsTypeInfoByName)) {
            return [];
        }
        return getRequiredFieldNamesForPage(page, formValues, elementsTypeInfoByName);
    });
    var correctableNames = pages.flatMap(function (page) {
        if (!isPageVisible(page, formValues, elementsTypeInfoByName)) {
            return [];
        }
        return getCorrectAnswerFieldNamesForPage(page);
    });
    return { fillableNames: fillableNames, requiredNames: requiredNames, correctableNames: correctableNames };
};
var FormProgressBar = function (_a) {
    var activePage = _a.activePage, pages = _a.pages, progressBarType = _a.progressBarType;
    var _b = useFormLogic(), formValues = _b.formValues, elementsTypeInfoByName = _b.elementsTypeInfoByName;
    var correctAnswerByName = useMemo(function () { return getCorrectAnswerMap(pages); }, [pages]);
    var _c = useMemo(function () {
        var totalPages = pages.length;
        if (progressBarType === ProgressBarType.QUESTIONS) {
            var fillableNames = getQuestionNames(pages, formValues, elementsTypeInfoByName).fillableNames;
            var total = fillableNames.length;
            var filled = fillableNames.filter(function (name) {
                return isValueFilled(formValues[name]);
            }).length;
            var progressValue_1 = total > 0 ? (filled / total) * 100 : 0;
            return {
                progress: progressValue_1,
                label: "".concat(filled, " de ").concat(total, " perguntas"),
            };
        }
        if (progressBarType === ProgressBarType.REQUIRED_QUESTIONS) {
            var requiredNames = getQuestionNames(pages, formValues, elementsTypeInfoByName).requiredNames;
            var total = requiredNames.length;
            var filled = requiredNames.filter(function (name) {
                return isValueFilled(formValues[name]);
            }).length;
            var progressValue_2 = total > 0 ? (filled / total) * 100 : 0;
            return {
                progress: progressValue_2,
                label: "".concat(filled, " de ").concat(total, " obrigat\u00F3rias"),
            };
        }
        if (progressBarType === ProgressBarType.CORRECT_ANSWERS) {
            var correctableNames = getQuestionNames(pages, formValues, elementsTypeInfoByName).correctableNames;
            var total = correctableNames.length;
            var correct = correctableNames.filter(function (name) {
                var _a;
                var userValue = formValues[name];
                var elementCorrectAnswer = correctAnswerByName[name];
                var elementTypeInfo = (_a = elementsTypeInfoByName[name]) !== null && _a !== void 0 ? _a : {};
                if (!isValueFilled(userValue) || !elementTypeInfo) {
                    return false;
                }
                return isCorrectAnswer(userValue, elementCorrectAnswer, elementTypeInfo);
            }).length;
            var progressValue_3 = total > 0 ? (correct / total) * 100 : 0;
            return {
                progress: progressValue_3,
                label: "".concat(correct, " de ").concat(total, " perguntas corretas"),
            };
        }
        if (totalPages === 0) {
            return {
                progress: 0,
                label: "Página 1 de 1",
            };
        }
        var progressValue = ((activePage + 1) / totalPages) * 100;
        return {
            progress: progressValue,
            label: "P\u00E1gina ".concat(activePage + 1, " de ").concat(totalPages),
        };
    }, [
        activePage,
        progressBarType,
        pages,
        formValues,
        elementsTypeInfoByName,
        correctAnswerByName,
    ]), progress = _c.progress, label = _c.label;
    return (_jsxs(Box, __assign({ sx: { mt: 3, mb: 2 } }, { children: [_jsx(LinearProgress, { variant: "determinate", value: progress }), _jsx(Typography, __assign({ variant: "caption", color: "text.secondary", sx: { mt: 1 } }, { children: label }))] })));
};
export default FormProgressBar;
